import { connect, MapStateToProps } from 'react-redux';
import { Props } from './FolderContentList';
import { AppState } from '../../../../../types/store';
import { getFullViewFolderIds } from '../../../../selectors/gallectionSection';

export type StateProps = Pick<Props, 'folderIds'>;
export type OwnProps = Omit<Props, keyof StateProps>;

const mapStateToProps: MapStateToProps<
  StateProps,
  OwnProps,
  AppState
> = state => ({
  folderIds: getFullViewFolderIds(state),
});

export default connect(mapStateToProps);
